export const emeaCountries = [
    "AF",
    "AL",
    "DZ",
    "AD",
    "AO",
    "AM",
    "AT",
    "AZ",
    "BH",
    "BY",
    "BE",
    "BJ",
    "BA",
    "BW",
    "BG",
    "BF",
    "BI",
    "CM",
    "CV",
    "CF",
    "TD",
    "KM",
    "CG",
    "CD",
    "CI",
    "HR",
    "CY",
    "CZ",
    "DK",
    "DJ",
    "EG",
    "GQ",
    "ER",
    "EE",
    "ET",
    "FO",
    "FI",
    "FR",
    "GA",
    "GM",
    "GE",
    "DE",
    "GH",
    "GI",
    "GR",
    "GN",
    "GW",
    "HU",
    "IS",
    "IR",
    "IQ",
    "IE",
    "IM",
    "IL",
    "IT",
    "JE",
    "JO",
    "KZ",
    "KE",
    "XK",
    "KW",
    "KG",
    "LV",
    "LB",
    "LS",
    "LR",
    "LY",
    "LI",
    "LT",
    "LU",
    "MG",
    "MW",
    "ML",
    "MT",
    "MR",
    "MU",
    "YT",
    "MD",
    "MC",
    "ME",
    "MA",
    "MZ",
    "NA",
    "NL",
    "NE",
    "NG",
    "MK",
    "NO",
    "OM",
    "PS",
    "PL",
    "PT",
    "QA",
    "RE",
    "RO",
    "RU",
    "RW",
    "SM",
    "ST",
    "SA",
    "SN",
    "RS",
    "SC",
    "SL",
    "SK",
    "SI",
    "SO",
    "ZA",
    "ES",
    "SH",
    "SD",
    "SJ",
    "SZ",
    "SE",
    "CH",
    "SY",
    "TJ",
    "TZ",
    "TG",
    "TN",
    "TR",
    "TM",
    "UG",
    "UA",
    "AE",
    "GB",
    "UZ",
    "VA",
    "EH",
    "YE",
    "ZM",
    "ZW",
    "Afghanistan",
    "Albania",
    "Algeria",
    "Andorra",
    "Angola",
    "Armenia",
    "Austria",
    "Azerbaijan",
    "Bahrain",
    "Belarus",
    "Belgium",
    "Benin",
    "Bosnia and Herzegovina",
    "Botswana",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cameroon",
    "Cape Verde",
    "Central African Republic",
    "Chad",
    "Comoros",
    "Congo",
    "Congo, The Dem. Republic Of",
    "Côte d'Ivoire",
    "Croatia",
    "Cyprus",
    "Czech Republic",
    "Denmark",
    "Djibouti",
    "Egypt",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Ethiopia",
    "Faroe Islands",
    "Finland",
    "France",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Gibraltar",
    "Greece",
    "Guinea",
    "Guinea-Bissau",
    "Hungary",
    "Iceland",
    "Iran",
    "Iraq",
    "Ireland",
    "Isle of Man",
    "Israel",
    "Italy",
    "Jersey",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kosovo",
    "Kuwait",
    "Kyrgyzstan",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Madagascar",
    "Malawi",
    "Mali",
    "Malta",
    "Mauritania",
    "Mauritius",
    "Mayotte",
    "Moldova",
    "Monaco",
    "Montenegro",
    "Morocco",
    "Mozambique",
    "Namibia",
    "Netherlands",
    "Niger",
    "Nigeria",
    "North Macedonia",
    "Norway",
    "Oman",
    "Palestinian Territory, Occupied",
    "Poland",
    "Portugal",
    "Qatar",
    "Réunion",
    "Romania",
    "Russian Federation",
    "Rwanda",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Slovakia",
    "Slovenia",
    "Somalia",
    "South Africa",
    "Spain",
    "St. Helena",
    "Sudan",
    "Svalbard/Jan Mayen Isls.",
    "Swaziland",
    "Sweden",
    "Switzerland",
    "Syria",
    "Tajikistan",
    "Tanzania",
    "Togo",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "Uzbekistan",
    "Vatican City",
    "Western Sahara",
    "Yemen",
    "Zambia",
    "Zimbabwe"
];